import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var MailFill = createIcon({
  displayName: 'MailFill',
  viewBox: '0 0 24 24',
  path: [/*#__PURE__*/_jsx("path", {
    d: "M12 11.39 3.06 5h17.88L12 11.39Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    d: "M2.12 5.55 12 12.61l9.88-7.06A1 1 0 0 1 22 6v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 .12-.45Z",
    fill: "currentColor"
  })]
});
//# sourceMappingURL=MailFill.js.map